import {Component, Inject, Input, OnInit} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef,} from '@angular/material/dialog';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {MainDataModels} from 'src/app/models/maindata-models';
import {ObjektModels} from 'src/app/models/objekt-models';
import {DatumFormatPipe} from 'src/app/pipes/datum-format.pipe';
import {MainDataService} from 'src/app/services/main-data.service';
import {MessageBoxService} from 'src/app/services/message-box.service';
import {ObjektDataService} from 'src/app/services/objekt-data.service';
import {SwissSettingsService} from 'src/app/services/swiss-settings.service';
import {v4 as uuidv4} from 'uuid';
import {ObjektAdresseComponent} from '../../objekte/objekt-adresse/objekt-adresse.component';

@Component({
    selector: 'app-notiz-eintrag', templateUrl: './notiz-eintrag.component.html', styleUrls: ['./notiz-eintrag.component.scss'],
})
export class NotizEintragComponent implements OnInit {
    @Input() formGroupNotiz: UntypedFormGroup;
    public cardTitle: string = 'MAIN_APP_DIALOG.INPUT_DIALOG.CREATE_NOTE.title';
    objekte: Array<MainDataModels.SearchFieldResponseObjekt> = []; // Leeres Objekte-Array erstellen (SearchFieldResponseObjekt[])
    filteredDescriptions?: Observable<MainDataModels.SearchFieldResponseObjekt[]>;
    public errormsg: string = '';
    public hasError: boolean = false;
    /* Mitarbeiterauswahl (event. mit Gruppen) */
    public dbMitarbeiter?: MainDataModels.Mitarbeiter[];
    public dbKategorien?: MainDataModels.Kategorie[];
    /* Objekt-Adressen */
    public objectAddresses: MainDataModels.ObjektAdresseSlim[] = [];
    public objIsChoosed: boolean = false;
    pageCounter: number = 1;
    public innerWidth: any;
    private currNotizMitBenutzer?: MainDataModels.NotizMitBenutzer;
    private objektAdresseDialogInput?: ObjektModels.ObjektAdresseDialogInput;

    constructor(private svcMainData: MainDataService, private swissSettings: SwissSettingsService, private svcObjektData: ObjektDataService, private svcMessageBox: MessageBoxService, public dialog: MatDialog, private _datumFormatPipe: DatumFormatPipe, public dialogRef: MatDialogRef<NotizEintragComponent>, @Inject(MAT_DIALOG_DATA) public data: MainDataModels.NotizMitBenutzer) {
        if (data) {
            this.currNotizMitBenutzer = this.data!;
            if (!this.currNotizMitBenutzer.istNeueNotiz) {
                this.cardTitle = 'MAIN_APP_DIALOG.INPUT_DIALOG.EDIT_NOTE.title';
            }
        } else {
            this.currNotizMitBenutzer = MainDataModels.EmptyNotizMitBenutzer();
        }

        this.formGroupNotiz = new UntypedFormGroup({
            fldPrivat: new UntypedFormControl(),
            fldKategorie: new UntypedFormControl(),
            fldObjekt: new UntypedFormControl(),
            fldAdresse: new UntypedFormControl(),
            fldTitel: new UntypedFormControl(),
            fldNotiz: new UntypedFormControl(),
            fldErledigt: new UntypedFormControl(),
            fldMitarbeiter: new UntypedFormControl(),
        });
    }

    ngOnInit(): void {
        this.innerWidth = window.innerWidth;
        if (!(this.data as any).position?.top) {
            this.dialogRef.updatePosition({top: '3.75rem'});
        }
        // Objekte für Objektsuche laden
        this.refreshSuchfeldBeschreibungen().then(() => {
            if (this.data.notiz.objectID) {
                const obj = this.objekte.find(obj => obj.objectID == this.data.notiz.objectID);
                if (obj) {
                    this.selectedSearchItem({option: {value: {objectID: this.data.notiz.objectID}}});
                    this.formGroupNotiz.controls['fldObjekt'].setValue(obj);
                }
            }
            // Mitarbeiter laden
            this.svcMainData.getMitarbeiterWithDB().then((res) => {
                this.dbMitarbeiter = res.filter((mi) => mi.active === 1).sort((a, b) => (a.loginname.toLocaleLowerCase() > b.loginname.toLocaleLowerCase() && 1) || -1);
                this.loadFieldValues();
            });

            // Termin-Kategorien laden
            this.svcMainData.getKategorienWithDB().then((res) => {
                this.dbKategorien = res;
            });

            this.filteredDescriptions = this.formGroupNotiz.controls['fldObjekt'].valueChanges.pipe(startWith(''), map((value) => this._filter(value)));
        });
    }

    nextPart() {
        if (this.pageCounter < 4) {
            this.pageCounter++;
        }
    }

    prevPart() {
        if (this.pageCounter > 1) {
            this.pageCounter--;
        }
    }

    // Hier werden die Namen für die Mitarbeiterauswahl angezeigt
    public getMitarbeiter(mi: MainDataModels.Mitarbeiter): string {
        let mitarbeiter = mi.loginname;
        if (mi.firstname && mi.lastname) {
            mitarbeiter += ' (' + mi.lastname + ' ' + mi.firstname + ')';
        } else if (mi.lastname) {
            mitarbeiter += ' (' + mi.lastname + ')';
        } else if (mi.firstname) {
            mitarbeiter += ' (' + mi.firstname + ')';
        }
        return mitarbeiter;
    }

    getObjektDesc(item: MainDataModels.SearchFieldResponseObjekt) {
        if (item) {
            return item.beschreibung;
        } else {
            return '';
        }
    }

    // Suchelement wurde angeklickt
    selectedSearchItem(event: any) {
        if (this.swissSettings.getWebConfig().debugMode) {
            console.log(event.option.value);
        }
        if (event) {
            this.currNotizMitBenutzer!.notiz.objectID = event.option.value.objectID;
            this.objIsChoosed = true;
            this.loadObjectAdressen();
        }
    }

    selectedAdress(event: any) {
        if (this.swissSettings.getWebConfig().debugMode) {
            console.log(event);
        }
        if (event) {
            this.currNotizMitBenutzer!.notiz.adressID = event.value.adressID;
        }
    }

    refreshSuchfeldBeschreibungen(): Promise<boolean> {
        return new Promise((resolve) => {
            this.objekte = [];
            this.svcObjektData
                .getSuchfeldBeschreibungen()
                .subscribe({
                    next: (res) => {
                        this.objekte = this.objekte.concat(res);
                        if (this.swissSettings.getWebConfig().debugMode) {
                            console.log('Geladene Objekte', this.objekte);
                        }
                        resolve(true);
                    },
                });
        });
    }

    save() {
        if (this.swissSettings.getWebConfig().debugMode) {
            console.log('Notiz-FormValues: ', this.formGroupNotiz.value);
        }

        try {
            if (this.formGroupNotiz.value) {
                // Kategorie(n)
                let kategorien = this.formGroupNotiz.controls['fldKategorie'].value;
                this.currNotizMitBenutzer!.notizKategorien = [];
                if (kategorien && kategorien.length > 0) {
                    kategorien.forEach((element: number) => {
                        let tkz: MainDataModels.NotizKategorieZuord = {
                            id: uuidv4(), noteID: this.currNotizMitBenutzer!.notiz.noteID, categoryID: this.dbKategorien!.filter((tk) => tk.id == element)[0].id,
                        };

                        this.currNotizMitBenutzer!.notizKategorien.push(tkz);
                    });
                }

                // Privat
                this.currNotizMitBenutzer!.notiz.private = this.formGroupNotiz.controls['fldPrivat'].value;

                // Adresse
                let adresse = this.formGroupNotiz.controls['fldAdresse'].value;
                if (adresse) {
                    this.currNotizMitBenutzer!.notiz.adressID = adresse.adressID;
                }

                // Mitarbeiter & Mitarbeitergruppen
                let mitarbeiter = this.formGroupNotiz.controls['fldMitarbeiter'].value;

                let mitarbeiterOhneGruppen: MainDataModels.Mitarbeiter[] = [];

                mitarbeiter.forEach((employee: number) => {
                    mitarbeiterOhneGruppen.push(this.dbMitarbeiter!.filter((mi) => mi.userID === employee)[0]);
                });
                this.currNotizMitBenutzer!.mitarbeiter = mitarbeiterOhneGruppen;

                // Titel
                this.currNotizMitBenutzer!.notiz.description = this.formGroupNotiz.controls['fldTitel'].value;

                // Notiz
                const noteText = this.formGroupNotiz.controls['fldNotiz'].value;
                this.currNotizMitBenutzer!.notiz.notes = typeof noteText === 'string'
                    ? noteText.replace(/\r\n|\r|\n/g, '\r\n')
                    : noteText;

                // Erledigt
                if (this.formGroupNotiz.controls['fldErledigt'].value === true) {
                    this.currNotizMitBenutzer!.notiz.done = 1;
                } else {
                    this.currNotizMitBenutzer!.notiz.done = 0;
                }

                if (this.swissSettings.getWebConfig().debugMode) {
                    console.log('notizMitBenutzer', this.currNotizMitBenutzer);
                }
            }

            if (this.hasError) {
                // Zuvor vorhandener Fehler zurücksetzen
                this.hasError = false;
                this.errormsg = '';
            }

            this.dialogRef.close(this.currNotizMitBenutzer);
        } catch (ex) {
            this.hasError = true;
            this.errormsg = 'Fehler bei der Speicherung der Notiz: ';
            console.error(this.errormsg, ex);
            this.svcMessageBox.showError('⚠️ ❗❗ Die Notiz konnte nicht gespeichert werden!! ❗❗ ⚠️', '!! FEHLER !!');
        }
    }

    addObjectAddress() {
        if (this.objIsChoosed) {
            this.objektAdresseDialogInput = {
                objektAdresseZuord: {
                    id: '00000000-0000-0000-0000-000000000000', objectID: this.currNotizMitBenutzer!.notiz!.objectID, addressType: 5, // Diverses
                    addressContact: 0, adressNumber: 0, adressID: '',
                }, blDoCheckUnique: true, blDisableAdrTypeSelect: false,
            };

            var dialogRef = this.dialog.open(ObjektAdresseComponent, {
                disableClose: true, width: '95%', data: this.objektAdresseDialogInput,
            });

            dialogRef.afterClosed().subscribe({
                next: (result) => {
                    if (result) {
                        this.objektAdresseDialogInput!.objektAdresseZuord = result;
                        if (this.objektAdresseDialogInput!.objektAdresseZuord) {
                            this.svcObjektData
                                .addObjectAddress(this.objektAdresseDialogInput!.objektAdresseZuord)
                                .subscribe({
                                    next: () => {
                                        this.loadObjectAdressen(this.objektAdresseDialogInput!.objektAdresseZuord.adressID);
                                        this.currNotizMitBenutzer!.notiz!.adressID = this.objektAdresseDialogInput!.objektAdresseZuord.adressID;
                                        if (this.objektAdresseDialogInput!.objektAdresseZuord.contactID) {
                                            this.currNotizMitBenutzer!.notiz!.contactID = this.objektAdresseDialogInput!.objektAdresseZuord.contactID;
                                        }
                                    }, error: (err) => console.error('Fehler: ', err),
                                });
                        }
                    }
                },
            });
        } else {
            this.svcMessageBox.showWarning('Objekt muss zuvor ausgewählt werden', '!! Warnung !!');
        }
    }

    private loadFieldValues() {
        // Felder abfüllen
        if (this.currNotizMitBenutzer && this.currNotizMitBenutzer.notiz) {
            //Neue Notiz
            if (this.currNotizMitBenutzer.istNeueNotiz) {
                if (this.currNotizMitBenutzer.notiz.responsible) {
                    let mitarbeiter = this.dbMitarbeiter?.filter((x) => x.loginname == this.currNotizMitBenutzer!.notiz.responsible)[0];
                    if (mitarbeiter) {
                        this.formGroupNotiz.get('fldMitarbeiter')!.setValue([mitarbeiter.userID]);
                    }
                }

                if (this.currNotizMitBenutzer!.notiz.objectID != '') {
                    this.objIsChoosed = true;
                    this.formGroupNotiz.get('fldObjekt')!.setValue(this.objekte.filter((o) => o.objectID === this.currNotizMitBenutzer!.notiz.objectID)[0]);
                    this.loadObjectAdressen();
                }
            } else {
                // Bestehende Notiz bearbeiten
                if (this.currNotizMitBenutzer.notiz.done === 1) {
                    this.formGroupNotiz.get('fldErledigt')!.setValue(1);
                }

                if (this.currNotizMitBenutzer.notizKategorien) {
                    let katis: number[] = [];
                    this.currNotizMitBenutzer.notizKategorien.forEach((nk) => {
                        katis.push(nk.categoryID);
                    });
                    this.formGroupNotiz.get('fldKategorie')!.setValue(katis);
                }

                if (this.currNotizMitBenutzer.notiz.private) {
                    this.formGroupNotiz.get('fldPrivat')!.setValue(1);
                }

                this.formGroupNotiz.get('fldObjekt')!.setValue(this.objekte.filter((o) => o.objectID === this.currNotizMitBenutzer!.notiz.objectID)[0]);
                this.objIsChoosed = true;
                this.loadObjectAdressen();

                if (this.currNotizMitBenutzer.notiz.description) {
                    this.formGroupNotiz.get('fldTitel')!.setValue(this.currNotizMitBenutzer.notiz.description);
                }

                if (this.currNotizMitBenutzer.notiz.notes) {
                    this.formGroupNotiz.get('fldNotiz')!.setValue(this.currNotizMitBenutzer.notiz.notes);
                }

                if (this.currNotizMitBenutzer.mitarbeiter) {
                    this.formGroupNotiz.get('fldMitarbeiter')!.setValue(this.currNotizMitBenutzer.mitarbeiter.map(emp => emp.userID));
                }
            }
        }
    }

    private _filter(value: string | { objectID: string, beschreibung: string }): MainDataModels.SearchFieldResponseObjekt[] {
        if (typeof value == 'string' && value) {
            const filterValue = value.toLowerCase();

            if (this.objekte && this.objekte.length > 0) {
                // Sternsuche
                if (filterValue.length > 1 && filterValue[0] === '*') {
                    const searchValue = filterValue.substring(1, filterValue.length);
                    return this.objekte.filter((objekt) => objekt.beschreibung && objekt.beschreibung.toLowerCase().indexOf(searchValue) >= 0);
                } else {
                    return this.objekte.filter((objekt) => objekt.beschreibung && objekt.beschreibung.toLowerCase().indexOf(filterValue) === 0);
                }
            } else {
                return this.objekte;
            }
        } else {
            return [];
        }
    }

    private loadObjectAdressen(adresseID: string = '') {
        this.svcMainData
            .getTerminObjektAdressen(this.currNotizMitBenutzer!.notiz.objectID)
            .subscribe({
                next: (res) => {
                    if (res) {
                        this.objectAddresses = res;
                        if (adresseID) {
                            let objAdr = this.objectAddresses.filter((oa) => oa.adressID === this.currNotizMitBenutzer!.notiz.adressID)[0];
                            this.formGroupNotiz.get('fldAdresse')!.setValue(objAdr);
                        } else {
                            // Wenn nur eine Adresse existiert, dann diese vorselektieren
                            if (this.objectAddresses.length === 1) {
                                this.formGroupNotiz
                                    .get('fldAdresse')!
                                    .setValue(this.objectAddresses[0]);
                            } else if (this.objectAddresses.length > 1) {
                                // Wenn es mehr als eine Kundenadresse hat --> gibt es eine Kundenadresse?
                                // Wenn ja, vorselektieren!
                                let objAdr = this.objectAddresses.filter((oa) => oa.typ === 1)[0];
                                if (objAdr) {
                                    this.formGroupNotiz.get('fldAdresse')!.setValue(objAdr);
                                }
                            }
                        }
                    }
                },
            });
    }
}
